export default {
    events: {},
    effects: {},
    requirements: {}
}